function parseData(data) {
  return JSON.stringify(data);
}

function parseRetrievedUserPreference(data) {
  if (data && data.edelPref != null) {
    return JSON.stringify({
      edelPref: data.edelPref
    });
  } else {
    return JSON.stringify({
      edelPref: 0
    });
  }
}

function serviceFactory({ api }) {
  const getUserPreferences = ({ metaData }) =>
    api.getUserPreferences(metaData)
      .then(parseRetrievedUserPreference)
      .catch(parseRetrievedUserPreference);

  const saveUserPreferences = ({ preference, screen, metaData }) =>
    api.saveUserPreferences(preference, screen, metaData)
      .then(parseData)
      .catch(parseData);

  return {
    getUserPreferences,
    saveUserPreferences,
  };
}

module.exports = serviceFactory;
